import { IndividualRun } from "@/types/metadata";

const getFinalMessage = (run: IndividualRun) => {
  return (run.request?.prompt_version?.prompt_template as any)?.messages?.pop();
};

const getFilteredValue = (value: string) => {
  return value
    .replace(/[\n\s]+/g, " ")
    .replace(/\s*\[\s*/g, "[")
    .replace(/\s*\]\s*/g, "]")
    .replace(/,(\s*[}\]])/g, "$1");
};

const parseTypeOptimistically = (value: any) => {
  try {
    const filteredValue = getFilteredValue(value);
    const jsonValue = JSON.parse(filteredValue);
    return jsonValue;
  } catch (e) {
    return value;
  }
};

export { getFinalMessage, parseTypeOptimistically, getFilteredValue };
